// extracted by mini-css-extract-plugin
export var item = "events-item-module--item--t1nss";
export var title = "events-item-module--title--fpI3c";
export var speakerWrapper = "events-item-module--speaker-wrapper--lBNID";
export var speaker = "events-item-module--speaker--kyACV";
export var link = "events-item-module--link--IzHgz";
export var img = "events-item-module--img--+z5XC";
export var wrapper = "events-item-module--wrapper--fjA9E";
export var imgWrapper = "events-item-module--img-wrapper--gEHmz";